/*
  ULTREIA v16 — encabezado: un solo agregado al comportamiento de Dawn.

  En la búsqueda, las flechas del teclado recorren los resultados
  (predictive-search.js marca la opción con aria-selected y la anuncia
  con aria-activedescendant en el campo), pero Dawn no la trae a la
  vista: en el celular, o con muchos resultados, la opción elegida
  quedaba abajo, fuera de la hoja. Acá se mira ese atributo y se lleva
  la opción a la vista, sin animación si se pidió movimiento reducido.
*/
(() => {
  const campo = document.getElementById('Search-In-Modal');
  if (!campo || !('MutationObserver' in window)) return;
  const quieto = window.matchMedia('(prefers-reduced-motion: reduce)');

  new MutationObserver(() => {
    const id = campo.getAttribute('aria-activedescendant');
    const opcion = id && document.getElementById(id);
    if (!opcion) return;
    opcion.scrollIntoView({ block: 'nearest', behavior: quieto.matches ? 'auto' : 'smooth' });
  }).observe(campo, { attributes: true, attributeFilter: ['aria-activedescendant'] });
})();
